import request from './request'

// 
export function getIndexHK(data) {
    return request({
        url: '/location/indexHK',
        method: 'get',
        params: data
    })
}



export function listDeviceGroup(data) {
    return request({
        url: '/deviceGroup/listDeviceGroup',
        method: 'get',
        params: data
    })
}

//今日在线
export function listDeviceLocationTodayOnline(data) {
    return request({
        url: '/device/listDeviceLocationTodayOnline',
        method: 'get',
        params: data
    })
}


export function listDeviceLocationTodayOffline(data) {
    return request({
        url: '/device/listDeviceLocationTodayOffline',
        method: 'get',
        params: data
    })
}


export function listDeviceOnlineCount(data) {

    if (!data.beginTime) {

        data.beginTime = getTodayBeginTime();

    }
    if (!data.endTime) {

        data.endTime = getCurrentEndTime();

    }
    return request({
        url: '/device/listDeviceOnlineCount',
        method: 'get',
        params: data
    })
}





function getFormattedDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export function getTodayBeginTime() {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // 设置时间为当天的00:00:00
    return getFormattedDate(today);
}

export function getCurrentEndTime() {
    const now = new Date(); // 获取当前时间
    return getFormattedDate(now);
}

export function getPreviousDate(days) {
    // 获取当前日期
    const currentDate = new Date();
    // 计算目标日期（当前日期减去指定天数）
    const targetDate = new Date(currentDate.setDate(currentDate.getDate() - days));
    // 使用已有的格式化函数返回目标日期的格式化字符串
    return getFormattedDate(targetDate);
}

//获取前多少小时的数据
export function getPreviousHour(hours) {
    // 获取当前时间
    const currentDate = new Date();
    // 计算目标时间（当前时间减去指定小时数）
    const targetDate = new Date(currentDate.getTime() - hours * 60 * 60 * 1000);
    // 使用已有的格式化函数返回目标时间的格式化字符串
    return getFormattedDate(targetDate);
}